import React, { useEffect, useMemo, useState } from "react";
import EnhancedDropdownComponent from "./EnhancedDropdownComponent.js";
import { Box } from "@material-ui/core";
import appFetch from "../../../api/appFetch.js";

const defaultFilter = () => true;
const defaultSort = () => 0;
const defaultMap = (x) => x;

const DataSourceDropdownComponent = ({
  value,
  values,
  sourceUrl,
  map: mapFunction,
  sort: sortFunction,
  filter: filterFunction,
  handleChange,
  onRequestEnd,
  onRequestStart,
  labelText,
  id,
  placeholder,
  containerClass,
  disabled = false,
  helperText,
  error = false,
  required = false,
  inputName = undefined,
  addMarginBottom = true
}) => {

  const [options, setOptions] = useState(values ?? []);

  const renderableOptions = useMemo(() => {
    return options.filter(filterFunction ?? defaultFilter)
      .sort(sortFunction ?? defaultSort)
      .map(mapFunction ?? defaultMap)
  }, [options, filterFunction, mapFunction, sortFunction])

  useEffect(() => {
    if (values) {
      setOptions(values);
      return;
    }

    if (!sourceUrl) return;

    if (onRequestStart) onRequestStart()

    // appFetch has no abort support, so guard setOptions instead - otherwise a
    // response arriving after unmount sets state on a dead component. onRequestEnd
    // must still fire: callers use it to re-enable save buttons.
    let cancelled = false;

    appFetch({
      url: sourceUrl,
      onSuccess: (response) => {
        if (!cancelled) setOptions(response);
      },
      onError: () => { },
      onFinalize: () => {
        if (onRequestEnd) onRequestEnd();
      }
    })

    return () => { cancelled = true; };
  }, [values, sourceUrl]);

  const computedRequired = useMemo(() => required && renderableOptions.length > 0, [required, renderableOptions])
  const validValue = useMemo(() => renderableOptions?.map(x => x.key).indexOf(value) >= 0, [renderableOptions, value]);

  return (
    <Box className={containerClass} padding="0">
      <EnhancedDropdownComponent
        id={id}
        labelText={labelText}
        value={validValue ? value : 0}
        placeholder={placeholder}
        options={renderableOptions}
        handleChange={handleChange}
        inputName={inputName}
        addMarginBottom={addMarginBottom}
        helperText={helperText}
        error={error || (computedRequired && !value)}
        disabled={disabled}
        required={computedRequired}
      />
    </Box>
  );
};

export default DataSourceDropdownComponent;
